import { useState } from "react";
import { MessageCircle, Upload, Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface MultiActionButtonProps {
  onChatClick: () => void;
  onUploadClick: () => void;
  hasNewMessages?: boolean;
  uploadCount?: number;
  className?: string;
}

export const MultiActionButton = ({
  onChatClick,
  onUploadClick,
  hasNewMessages,
  uploadCount = 0,
  className
}: MultiActionButtonProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!isExpanded) {
    return (
      <Button
        onClick={() => setIsExpanded(true)}
        className={cn(
          "fixed bottom-20 right-4 h-14 w-14 rounded-full shadow-lg z-50 animate-scale-in bg-primary hover:bg-primary/90",
          className
        )}
        size="icon"
      >
        <Plus className="h-6 w-6 text-primary-foreground" />
        {(hasNewMessages || uploadCount > 0) && (
          <div className="absolute -top-1 -right-1 h-4 w-4 bg-destructive rounded-full animate-pulse" />
        )}
      </Button>
    );
  }

  return (
    <div className="fixed bottom-20 right-4 z-50 flex flex-col-reverse gap-3">
      {/* Chat Button */}
      <Button
        onClick={onChatClick}
        className="h-14 w-14 rounded-full bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg animate-scale-in"
        size="icon"
        title="Chat öffnen"
      >
        <MessageCircle className="h-6 w-6" />
        {hasNewMessages && (
          <div className="absolute -top-1 -right-1 h-4 w-4 bg-destructive rounded-full animate-pulse" />
        )}
      </Button>

      {/* Upload Button */}
      <Button
        onClick={onUploadClick}
        className="h-14 w-14 rounded-full bg-secondary hover:bg-secondary/90 text-secondary-foreground shadow-lg animate-scale-in"
        size="icon"
        title="Uploads anzeigen"
      >
        <Upload className="h-6 w-6" />
        {uploadCount > 0 && (
          <div className="absolute -top-1 -right-1 h-5 w-5 bg-destructive rounded-full animate-pulse flex items-center justify-center text-xs font-medium text-destructive-foreground">
            {uploadCount}
          </div>
        )}
      </Button>

      {/* Close Button */}
      <Button
        onClick={() => setIsExpanded(false)}
        className="h-14 w-14 rounded-full bg-muted hover:bg-muted/90 text-muted-foreground shadow-lg"
        size="icon"
        title="Schließen"
      >
        <X className="h-6 w-6" />
      </Button>
    </div>
  );
};
